import {
  CANDIDATE_JOB_HISTORY_REQUEST, CANDIDATE_JOB_HISTORY_FAIL, CANDIDATE_JOB_HISTORY_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const CandidateInterviewHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_JOB_HISTORY_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case CANDIDATE_JOB_HISTORY_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case CANDIDATE_JOB_HISTORY_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default CandidateInterviewHistoryReducer;
